import { Button } from '@bnetex/ui-kit/button';
import { DataChip, DataChipVariant } from '@bnetex/ui-kit/dataChip';
import type { BaseModalProps } from '@bnetex/ui-kit/modal';
import { useTranslation } from 'react-i18next';
import s from './subscriptionStatusContent.module.scss';

interface SubscriptionStatusContentProps extends BaseModalProps {
    status: Omit<NotificationPermission, 'default'>;
}

export const SubscriptionStatusContent = ({ onClose, status }: SubscriptionStatusContentProps) => {
    const { t } = useTranslation('notifications');

    const [ text, variant ]: [string, DataChipVariant] = status === 'granted'
        ? [ t('notificationsSuccess'), DataChipVariant.SUCCESS ]
        : [ t('notificationsBanned'), DataChipVariant.ERROR ];

    return (
        <div className={s['container']}>
            <DataChip
                text={text}
                variant={variant}
            />
            <Button
                fillContainer={true}
                text={t('gotIt')}
                onClick={() => onClose()}
            />
        </div>
    );
};
